import React from "react";
import {Printers} from "./printers/Printers";
import {HeaderTabs} from "./common/HeaderTabs";
import {QueryClient, QueryClientProvider} from 'react-query';

const queryClient = new QueryClient();

export const PrintersMain = () => {

    const headerLinks = [
        { label: "Organization printers", path: "printers" },
        { label: "Materials stock", path: "resources" }
    ];

    return (
        <>
            <HeaderTabs links={headerLinks}/>

            <div id="main-grid__item--main-content" className="main-grid__item">
                <div id="main-content">
                    <QueryClientProvider client={queryClient}>
                        <Printers/>
                    </QueryClientProvider>
                </div>
            </div>
        </>
    )
}



